import {get, post} from './common.js';

export function registerUser(userData) {
    return post('/register/', userData);
}

export function signupUser(email) {
   return post('/signup/', {email: email});
}